import ModalAlert from 'src/components/ModalAlert'

/**
 * Plugin mở Modal theo kiểu thư viện (giống SweetAlert): chỉ cần gọi
 * `this.$modal({ ... })` và nhận về một Promise.
 *
 * Popup luôn rộng 512px (full-width khi màn hình < 512px), nền trắng,
 * backdrop đen 40%, đóng được bằng nút Cancel / click nền / phím Esc.
 *
 * Cách dùng:
 *   this.$modal({
 *     type: 'success',           // success | error | warning | info | question
 *     html: 'Nội dung <b>HTML</b>',
 *     showCancelButton: true,
 *     TextCancelButton: 'Cancel',
 *     showConfirmButton: false,
 *     TextConfirmButton: '',
 *     showCustomButton: false,
 *     TextCustomButton: '',
 *     confirmAction: () => {},   // callback khi bấm nút Confirm
 *     CancelAction: () => {},    // callback khi bấm nút Cancel
 *     CustomAction: () => {}     // callback khi bấm nút Custom
 *   }).then(({ action }) => {
 *     // action: 'confirm' | 'cancel' | 'custom' | 'close'
 *   })
 */
const ModalPlugin = {
  install(VueCtor, options = {}) {
    // i18n / store dùng chung với app để $t hoạt động bên trong instance con
    const { i18n, store } = options

    const open = (params = {}) => {
      // Tách callback ra khỏi props truyền cho component
      const { confirmAction, CancelAction, CustomAction, ...props } = params

      // Cho phép đóng modal từ bên ngoài qua `promise.close()`,
      // giống `goAway()` của $toasted (dùng để thay thế popup "đang xử lý")
      let destroy = () => {}

      const promise = new Promise((resolve) => {
        const ModalCtor = VueCtor.extend(ModalAlert)
        const instance = new ModalCtor({
          i18n,
          store,
          propsData: { ...props }
        })

        let settled = false
        destroy = (result) => {
          if (settled) return
          settled = true
          // Lưu element thật trước khi $destroy (sau khi destroy $el vẫn còn tham chiếu)
          const el = instance.$el
          instance.$destroy()
          if (el && el.parentNode) {
            el.parentNode.removeChild(el)
          }
          // Gọi callback tương ứng với nút được bấm
          const action = result && result.action
          if (action === 'confirm' && typeof confirmAction === 'function') {
            confirmAction(result)
          } else if (action === 'cancel' && typeof CancelAction === 'function') {
            CancelAction(result)
          } else if (action === 'custom' && typeof CustomAction === 'function') {
            CustomAction(result)
          }
          resolve(result)
        }

        instance.$on('result', destroy)
        // Mount không cần phần tử có sẵn: Vue tạo $el rồi ta tự gắn vào body
        instance.$mount()
        document.body.appendChild(instance.$el)
      })

      promise.close = () => destroy({ action: 'close' })

      return promise
    }

    VueCtor.prototype.$modal = open
    VueCtor.$modal = open
  }
}

export default ModalPlugin
